define.alias("ember-composable-helpers/helpers/compute", "settings/helpers/compute");